export const DEM_MANUFACTURER_URL_PARAM = "manufacturer"
export const DEM_MANUFACTURER_API_FIELD = "device_manufacturers"
export const DEM_MANUFACTURER_REF_KEY = "deviceManufacturers"

export const DEM_MODEL_URL_PARAM = "model_reference"

export const DEM_VOLTAGE_URL_PARAM = "voltage"
export const DEM_VOLTAGE_API_FIELD = "device_voltages"
export const DEM_VOLTAGE_REF_KEY = "deviceVoltages"

export const DEM_STATUS_URL_PARAM = "compliance_status"
export const DEM_STATUS_API_FIELD = "compliance_status"
export const DEM_STATUS_REF_KEY = "compliance_status"

export const DEM_PHASE_URL_PARAM = "phase"
export const DEM_PHASE_API_FIELD = "device_phases"
export const DEM_PHASE_REF_KEY = "phases"

export const DEM_TYPE_URL_PARAM = "device_type"
export const DEM_TYPE_API_FIELD = "device_types"
export const DEM_TYPE_REF_KEY = "deviceTypes"

// Raw API input type
type TDemandRefInput = {
    device_manufacturers: string[]
    device_models: string[]
    device_voltages: number | string[]
    device_phases: number | string[]
    device_types: string[]
}

// Mapper Output type
export type TDemandRefOutput = {
    deviceManufacturers: string[]
    deviceVoltages: number | string[]
    phases: number | string[]
    deviceTypes: string[]
}

// Overall output type
type TDemandFilterReferenceMapper = {
    map: (response: unknown) => TDemandRefOutput
}
export const demandFilterReferenceMapper: TDemandFilterReferenceMapper = {
    /**
     * Maps API response into UI data model and replaces missing arrays. Appends
     * in static option jurisdiction. This is for demand search reference
     * data
     */
    map: (response: unknown) => ({
        [DEM_MANUFACTURER_REF_KEY]:
            (response as TDemandRefInput)[DEM_MANUFACTURER_API_FIELD] || [],
        [DEM_VOLTAGE_REF_KEY]:
            (response as TDemandRefInput)[DEM_VOLTAGE_API_FIELD] || [],
        [DEM_PHASE_REF_KEY]:
            (response as TDemandRefInput)[DEM_PHASE_API_FIELD] || [],
        [DEM_TYPE_REF_KEY]:
            (response as TDemandRefInput)[DEM_TYPE_API_FIELD] || [],
    }),
}
